import React, { useContext, Fragment } from "react";
import { Typography, Grid, TextField, Button, Avatar } from "@material-ui/core";
import { MainContext } from "../context/main";
import { Theme, makeStyles } from "@material-ui/core/styles";
import { AccountCircle } from "@material-ui/icons";

const useStyle = makeStyles((theme: Theme) => ({
  root: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: theme.spacing(4),
  },
  gridcontainer: {
    padding: theme.spacing(2),
  },
  textfield: {
    "& .MuiInputBase-input": {
      fontWeight: 200,
    },
  },
  label: { fontWeight: 400 },
  gridflexend: { display: "flex", width: "100%", justifyContent: "flex-end" },
  btn: { textTransform: "unset", fontWeight: "bold" },
  btnupdate: {
    textTransform: "unset",
    fontWeight: "bold",
    marginLeft: theme.spacing(2),
  },
  whiteIcon: {
    color: theme.palette.common.black,
    width: theme.spacing(16),
    height: theme.spacing(16),
    cursor: "pointer",
  },
  avatar: {
    width: theme.spacing(16),
    height: theme.spacing(16),
    cursor: "pointer",
  },
  input: {
    display: "none",
  },
  fonthead: { fontWeight: "bold" },
  image: { paddingTop: theme.spacing(2), paddingBottom: theme.spacing(2) },
}));

interface ImageChange {
  onChangeImage: any;
  imagefile: any;
}

export const ProfileContentLeft = (props: ImageChange) => {
  const classes = useStyle();
  const { userInfo } = useContext(MainContext);
  const { onChangeImage, imagefile } = props;
  return (
    <div className={classes.root}>
      <Typography variant="body1" className={classes.fonthead}>
        Your Profile
      </Typography>
      <div className={classes.image}>
        {imagefile !== "" ? (
          <Fragment>
            {userInfo?.role === "customer" ? (
              <input
                accept="image/*"
                className={classes.input}
                id="icon-button-file"
                type="file"
                onChange={(e) => {
                  onChangeImage(e);
                }}
              />
            ) : null}

            <label htmlFor="icon-button-file">
              <Avatar id="preview" src={imagefile} className={classes.avatar} />
            </label>
          </Fragment>
        ) : (
          <Fragment>
            {userInfo?.role === "customer" ? (
              <input
                accept="image/*"
                className={classes.input}
                id="icon-button-file"
                type="file"
                onChange={(e) => {
                  onChangeImage(e);
                }}
              />
            ) : null}

            <label htmlFor="icon-button-file">
              <AccountCircle fontSize="large" className={classes.whiteIcon} />
            </label>
          </Fragment>
        )}
      </div>

      <Typography variant="body1">{`${userInfo?.first_name} ${userInfo?.last_name}`}</Typography>
      <Typography color="primary" variant="body1">{`${userInfo?.role
        .charAt(0)
        .toUpperCase()}${userInfo?.role.slice(1)}`}</Typography>
    </div>
  );
};

interface UserList {
  usersData: any;
  onChangeUser: any;
  process: boolean;
  onCancel: any;
  onUpdate: any;
}

export const ProfileContentRight = (props: UserList) => {
  const { usersData, onChangeUser, process, onCancel, onUpdate } = props;
  const classes = useStyle();
  const { userInfo } = useContext(MainContext);
  return (
    <Grid container spacing={2} className={classes.gridcontainer}>
      {usersData.map((rs: any, index: any) => {
        return (
          <Grid item xs={6} key={rs.title}>
            <TextField
              id={`text_${rs.name}`}
              label={rs.title}
              name={rs.name}
              fullWidth
              className={classes.textfield}
              value={rs.value}
              onChange={(e) => {
                if (userInfo?.role === "customer") {
                  onChangeUser(e, index);
                } else {
                }
              }}
              InputLabelProps={{
                className: classes.label,
              }}
            />
          </Grid>
        );
      })}
      {userInfo?.role === "customer" ? (
        <Grid item xs={12} className={classes.gridflexend}>
          <Button
            className={classes.btn}
            variant="contained"
            color="secondary"
            disabled={Boolean(process)}
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button
            className={classes.btnupdate}
            variant="contained"
            color="primary"
            autoFocus
            disabled={Boolean(process)}
            onClick={onUpdate}
          >
            Update
          </Button>
        </Grid>
      ) : null}
    </Grid>
  );
};
